export default __webpack_public_path__ + "static/media/phoneEquip5.6d7b08df.png";